import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { isValidPassword, PASSWORD_RULES_MESSAGE } from '../utils/passwordPolicy';

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (!isValidPassword(password)) {
      setError(PASSWORD_RULES_MESSAGE);
      return;
    }

    setLoading(true);
    try {
      await api.post(`/auth/reset-password/${token}`, { password, passwordConfirm });
      navigate('/login', { state: { message: 'Senha redefinida com sucesso. Faça login.' } });
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao redefinir a senha.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="page-container form-page">
      <h2>Redefinir senha</h2>
      <form onSubmit={handleSubmit} className="form-card">
        {error && <div className="alert-error">{error}</div>}
        <label>
          Nova senha
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            minLength={8}
            autoComplete="new-password"
          />
          <small style={{ color: '#888', fontSize: '0.8rem' }}>{PASSWORD_RULES_MESSAGE}</small>
        </label>
        <label>
          Confirmar nova senha
          <input
            type="password"
            value={passwordConfirm}
            onChange={e => setPasswordConfirm(e.target.value)}
            required
            autoComplete="new-password"
          />
        </label>
        <button type="submit" className="btn-primary" disabled={loading}>
          {loading ? 'Salvando...' : 'Redefinir senha'}
        </button>
      </form>
    </main>
  );
}
